import React from 'react';

export default function ClaimsPage() {
    return (
        <section id="body">
            <div className="container">
                
                <div className="row shadow title position-relative">
					<div className="col-12">
						<h2 className="text-center m-5 text-white fw-bold">CLAIMS</h2>
					</div>
				</div>
			<div className="row content ">
					<div className="col-1"></div>
					<div className="col-10 shadow bg-white rounded p-5">
                        <p>
                            As your insurance broker, we are committed to protecting your best interests. If you have any questions or need assistance with the instaPol website or your claims, we are here to assist. You may reach us via any of our available contact channels.

                        </p>
                        {/* <div className="row">
                            <label className="col-11 col-form-label text-center">
                                Email: <a href="mailto:instaPol@my.howdengroup.com">instaPol@my.howdengroup.com</a>
                            </label>
                        </div> */}

                        <p className="fw-bold">Contact Us</p>
                        <div className="row">
                            <div className="col-12 col-sm-4">
                                <p className="fw-bold">Customer Service Careline</p>
                            </div>
                            <div className="col-12 col-sm-6">
                                <a href="tel:+60122606183">+60122606183</a>
                                <p>Operating Hours: Monday to Friday (8:-45 am to 5:45 pm)</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-4">
                                <p className="fw-bold">WhatsApp No.</p>
                            </div>
                            <div className="col-12 col-sm-6">
                                <a target="_blank" href={"https://api.whatsapp.com/send?phone=0122606183&text=" + process.env.MIX_APP_NAME}>+60122606183</a>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-4">
                                <p className="fw-bold">or Scan QR Code to WhatsApp</p>
                            </div>
                            <div className="col-12 col-sm-6">
                                <img src="images/whatsapp-qr.png" alt="WhatsApp" width="120"></img>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-4">
                                <p className="fw-bold">Email Us at</p>
                            </div>
                            <div className="col-12 col-sm-6">
                                <a href="mailto:insta.admin@howdengroup.com">insta.admin@howdengroup.com</a>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <h4 className="col-11 col-form-label ">Documents for claims submission:</h4>
                        </div>
                        <div className="row my-3">
                            <div className="col-12 border-end">
                                <label className="col-11 col-form-label  text-primary fw-bold">Bicycle Protection</label>
                                {/*<ol type="i" className="text-center">
                                    <li class="text-align: right;">Completed claims notification form</li>
                                    <li class="text-align: right;">Repair or replacement bill</li>
                                    <li class="text-align: right;">Pictures of damage bicycle / parts</li>
                                    <li class="text-align: right;">Proof of ownership (if available)</li>
                                </ol>
                                <label className="col-11 col-form-label text-center">Police report is mandatory for:</label>
                                <ol type="a" className="text-center">
                                    <li class="text-align: right;">Theft Claims</li>
                                    <li class="text-align: right;">Accidental claim above RM3,000</li>
                                </ol>
				*/}
                            <label className="col-11 col-form-label pl-5">
                                i.	Completed claims notification form
                            </label>
                            <label className="col-11 col-form-label pl-5">
                                ii.	Repair or replacement bill                           
				</label>                      	 	
                            <label className="col-11 col-form-label pl-5">
                                iii.	Pictures of damage bicycle / parts
                            </label>                       	 	
                            <label className="col-11 col-form-label pl-5">
                                iv.	Proof of ownership (if available)
                            </label>
                       	 	
 			 <label className="col-11 col-form-label  text-primary fw-bold">
					Police report is mandatory for:
				</label>
				
                            <label className="col-11 col-form-label pl-5">
                                i.	Theft Claims
                            </label>
                            <label className="col-11 col-form-label  pl-5">
                                ii.	Accidental claim above RM3,000
                            </label>
                       	 	
				<label className="col-11 col-form-label  mt-3">
                                    Download claim form here <a href="pdf/Claims Notification Form.pdf" target="_blank">Claims Notification Form</a>
                                </label>

                            </div>
				
                            
                        </div>
                    
			
                </div>
            </div>
	</div>
            <div className="row footer my-5">
				<div className="col-12 text-end">
					<a className="btn btn-success me-3" href="/Landing">Return to Home Page</a>
					<a className="btn btn-success" href="/BIKE">Get Quote</a>
				</div>
			</div>
        </section>
    );
}